import { useMemo, useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import DiagnosisComponent from "./DiagnosisComponent";
import { Col, Container, Row } from "react-bootstrap";
import { Breadcrumbs } from "components/Common/Common";
import { getClientBreadCrumbs, userFullName } from "helpers/common";




const singleNote = { note: "", disable: false };

const DiagnosisPage = () => {
    const navigate = useNavigate()
    const { clientId, clientType } = useParams()

    const [clientDetails, setClientDetails] = useState(null)
    
    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Diagnosis"), [clientType, clientDetails, clientId]);


    return (
        <>
            <section
                className={`position-relative ClientDetail`}
            >
                <Container fluid>
                    <Row style={{ paddingLeft: '12px' }} className="pt-3">
                        <Col lg="6">
                            <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                        </Col>
                    </Row>
                    <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                        <Row className="justify-content-between" >
                            <Col lg='9'>
                                <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                    DIAGNOSIS AND SEVERITY
                                </p>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-2">

                        <DiagnosisComponent setClientDetails={setClientDetails} client_id={clientId} isPage={true} />
                    </div>
                </Container>
            </section>
        </>
    );

};

export default DiagnosisPage;